export default __webpack_public_path__ + "static/media/ic-teachers.a6189562.svg";